import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5486sst2u: FaireProductEntity = {
  token: "p_q5486sst2u",
  type: "product",
  name: "Chalcopyrite Spheres",
  brandToken: "b_ciwhgi8nfq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9373b2c0b46f97b619d147d0d26c7d8f990a5c9384a13947bac4b6df83779c9e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3bacb4e9afa6d7ce0e1f6feb80205bfc5a242dfcd1eb4d08bd6eb6432b426bf5.jpeg",
    "https://cdn.faire.com/fastly/c422fa52aaa4d2a663d3792ce7e458ddcae1a77e624b4f370be4ce5bed8f4b24.jpeg",
  ],
  priceDollars: 44.34,
  description:
    "✨ Chalcopyrite Spheres ✨\n\nThese chalcopyrite spheres—often called peacock pyrite—feature a dazzling mix of gold, purple, blue, and green tones with a natural metallic luster. Polished into a smooth spherical shape, each piece reflects light beautifully, highlighting the stone’s coloration from every angle.\n\nEye-catching and energetic, these spheres make striking focal points for shelves, display trays, or paired with stands. These are about ~1.75 inches across.\n\nProduct Details\n• Polished chalcopyrite spheres\n• Metallic gold\n• Smooth, evenly shaped sphere\n• Color intensity and pattern vary naturally\n• Each piece is unique in sheen and coloration\n• Ideal for statement displays, collector shelves, and gift sections\n• Natural stone with surface treatments common to enhance color — variations are expected and embraced\n\nChalcopyrite is often associated with abundance, confidence, and creative energy, and its vivid coloration makes it especially appealing to customers drawn to bold, high-impact stones.\n\nA standout choice for shops offering metallic spheres, and visually striking wholesale pieces that immediately catch the eye. ✨",
  tags: [],
  msrpDollars: 88.68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:17.671Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
